// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__yEgVW","modalContent":"Modal_modalContent__JODE3","open":"Modal_open__5Nr7u","closeModal":"Modal_closeModal__cI8zy"};